/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:a466426c-1d8c-49a3-a482-9924a0b9b9fd",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_ObsrWT56r",
    "aws_user_pools_web_client_id": "793odrrons2jmfjd8313rjalkl",
    "oauth": {
        "domain": "test0923b086-0923b086-custportal.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://portal.doctor.route-53.aws.dev/,http://localhost:3000/",
        "redirectSignOut": "https://portal.doctor.route-53.aws.dev/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
